// Anything exported from this file is importable by other in-browser modules.
// import UsersService from "./UsersService";

import UsersService from "./UsersService";

export default UsersService;

export {
  getCookie,
  setCookie,
  eraseCookie,
  getJwt,
  getCustomerCookie,
} from "./cookie-helpers";

export { generateEmbedUrl } from "./sigmaEmbedHelper";
